import React, { Component } from 'react'
import Logo from '../../img/banner_logo.png'
import { Link, Redirect } from 'react-router-dom'
import { logout } from '../../store/actions/user'
import { connect } from 'react-redux'
import { apiEmployee } from '../../services/apiamrg'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons'

import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import './styles.css'

class Header extends Component {

    state = {
        token: '',
        usuario: '',
        empresa: '',
        redirect: false
    }

    componentDidMount = () => {
        this.getNome();
    }

    getNome = async () => {
        if (this.props.id === 999999) {
            apiEmployee.get(`/nomeEmpresaAdmin/${localStorage.getItem('empresaID')}`)
            .then(res => {
                this.setState({
                empresa: res.data[0].empresaNome,
                usuario: 'Marinete',
            })})
        } else {
        apiEmployee.get(`/nomeEmpresa/${this.props.id}`)
            .then(res => {
                this.setState({
                empresa: res.data[0].empresaNome,
                usuario: res.data[0].nome,
            })})
        }
    }
    fazerLogout = async () => {
        await this.props.onLogout()
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>RS Refeições</h1>
                        <p>Logout realizado!</p>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-50"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Ok
                        </button>
                    </div>
                )
            }
        })
        await this.setState({ redirect: true })
        await localStorage.removeItem('empresaID')
    }

    render() {
        return (
            <div className="header_wrapper" style={this.props.simplify ? {boxShadow: "none"} : {}}>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                <div className="header_logo">
                    <Link to={{ pathname: `/pedidos` }}>
                        <img alt='logo' className=" img-fluid logologado" src={Logo} style={{ alignItems: 'center', justifyContent: 'center' }} />
                    </Link>
                </div>
                <hr className="header_hr" style={this.props.simplify ? {display: "none"} : { marginBottom: 0 }} />
                <div className='header_nav' style={this.props.simplify ? {display: "none"} : {}}>
                    <div className='nav_left'>
                        <div className='nav_item'>
                            <Link className="nonlink" to={{ pathname: `/pedidos` }}>
                                Pedidos
                            </Link>
                        </div>
                        <div className='nav_item'>
                            <Link className="nonlink" to={{ pathname: `/vouchers` }}>
                                Vouchers
                            </Link>
                        </div>
                        <div className='nav_item'>
                            <Link className="nonlink" to={{ pathname: `/programacao` }}>
                                Programação
                            </Link>
                        </div>
                        <div className='nav_item'>
                            <Link className="nonlink" to={{ pathname: `/usuarios` }}>
                                Usuários
                            </Link>
                        </div>
                        <div className='nav_item'>
                            <Link className="nonlink" to={{ pathname: `/relatorios` }}>
                                Relatórios
                            </Link>
                        </div>

                    </div>
                    <div className='nav_right'>
                        <div className='nav_item_static'>Usuário: {this.state.usuario}</div>
                        <div className='nav_item_static'>Empresa: {this.state.empresa}</div>
                        {!this.props.hideLogout &&
                            <div className='nav_item'>
                                <FontAwesomeIcon cursor="pointer" onClick={() => this.fazerLogout()} icon={faSignOutAlt} color="white" size='2x' />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogout: () => dispatch(logout())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);